var exports = {
  "Z8": "BioEditor.module__emojiButton___cmlZcF",
  "Dg": "BioEditor.module__emojiButtonActive___cmlZcF",
  "h_": "BioEditor.module__description___cmlZcF",
  "EN": "BioEditor.module__editor___cmlZcF",
  "E": "BioEditor.module__characterCountContainer___cmlZcF",
};

module.exports = exports;
